import { useRouter } from 'next/router';
import { memo, useCallback } from 'react';

import { AirNotificationList } from '~/components/AirNotifications/components/AirNotificationList';
import { AnnouncementsNewsList } from '~/components/AirNotifications/components/AnnouncementsNewsList';
import { MobileNotificationFooter } from '~/components/AirNotifications/components/MobileNotificationFooter';
import { MobileNotificationsHeader } from '~/components/AirNotifications/components/MobileNotificationsHeader';
import { useMarkAllNotificationsAsRead } from '~/components/AirNotifications/hooks/useMarkAllNotificationsAsRead';
import { useNotificationsPanelTab } from '~/components/AirNotifications/hooks/useNotificationsPanelTab';
import { Routes } from '~/constants/routes';

export type MobileAirNotificationsProps = {
  onClose?: () => void;
};

export const MobileNotifications = memo(({ onClose }: MobileAirNotificationsProps) => {
  const router = useRouter();
  const { markAllNotificationsAsRead } = useMarkAllNotificationsAsRead();
  const { filters, isNewsTab, notificationFilter, onFilterClick } = useNotificationsPanelTab();

  const handleNotificationSettings = useCallback(() => {
    onClose?.();
    router.push(Routes.account.notificationSettings);
  }, [onClose, router]);

  return (
    <div className="flex h-full flex-col">
      <MobileNotificationsHeader
        onClose={onClose}
        onMarkAllAsRead={markAllNotificationsAsRead}
        onNotificationSettings={handleNotificationSettings}
      />

      {isNewsTab ? (
        <AnnouncementsNewsList />
      ) : (
        <AirNotificationList filter={notificationFilter} onNotificationClick={onClose} />
      )}

      <MobileNotificationFooter filters={filters} onFilterClick={onFilterClick} />
    </div>
  );
});

MobileNotifications.displayName = 'MobileNotifications';
